// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__32vyx","col":"styles_col__3xEAb"};